<kendo-formfield [formGroup]="formGroup">
  <kendo-label [text]="'discountsCard.label' | translate">
    <kendo-dropdownlist
      [data]="discountCards()"
      [defaultItem]="{
        name: 'discountsCard.placeholder' | translate,
        id: null
      }"
      textField="name"
      valueField="id"
      size="medium"
      formControlName="discountCard">
    </kendo-dropdownlist>
  </kendo-label>
</kendo-formfield>
